module.exports = __webpack_public_path__ + "img/man_dancing.b7da6422.gif";